import { useRouter } from 'next/router';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { RangeDatePicker } from '@/modules/workingDayReconciliation/components/Header/RangeDatePicker';
import { WorkerSearch } from '@/modules/workingDayReconciliation/components/Header/WorkerSearch';
import { WorkingDayReconciliationContext } from '@/modules/workingDayReconciliation/context/context';
import { Typography } from '@/shared/components/atoms';
import Tabs from '@/shared/components/atoms/Tabs';
import { CreateSettlement } from '@/shared/components/molecules';

const Header = () => {
  const { t } = useTranslation('common');
  const { query } = useRouter();
  const {
    state: { endDate, startDate },
  } = useContext(WorkingDayReconciliationContext);

  return (
    <div className='mb-7 flex flex-col gap-16'>
      <div className='flex w-full items-center justify-between'>
        <Typography variant='h2' weight='bold'>
          {t('dailyDuesDetails')}
        </Typography>
        <CreateSettlement endDate={endDate} startDate={startDate} />
      </div>

      <div className='flex w-full items-center justify-between'>
        <Tabs
          tabsList={[
            {
              id: 'crew',
              type: 'crew',
              label: t('Crews'),
            },
            {
              id: 'worker',
              type: 'worker',
              label: t('workers'),
            },
          ]}
          getLabel={(tab) => tab.label}
          getValue={(tab) => tab.type}
          tabQueryIndicator='type'
          variant='connected'
          defaultValue='crew'
        />
        <div className='flex items-center gap-2'>
          <RangeDatePicker />
          {query.type === 'worker' && (
            <>
              <div className='h-11 min-h-full w-[1px] bg-neutralVariant-90' />
              <WorkerSearch type='daily-due' />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export { Header };
